module.exports = __webpack_public_path__ + "img/news-4.b168dc62.jpg";